import axios from "axios";
import { getToken } from "./auth.api";

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const GTD_CATEGORIAS = ["Imediatamente", "Urgente", "Monitorar", "Aguardar", "Algum dia", "Finalizados"];

export async function getGtdTickets() {
  const { data } = await api.get("/gtd/tickets");
  return data;
}

/* União dos tickets programados na sprint ativa com os que têm tarefas
   internas em Acompanhamento de Tarefas — usada para o modal "Adicionar ticket". */
export async function getGtdCandidatos() {
  const { data } = await api.get("/gtd/candidatos");
  return data;
}

export async function upsertGtdTicket(idTicket, categoria, observacao) {
  const { data } = await api.put(`/gtd/tickets/${idTicket}`, { categoria, observacao });
  return data;
}

/* Define a ordem (prioridade de atendimento) dos tickets dentro de uma coluna.
   ordens: [{ id_ticket, ordem }] */
export async function reordenarGtd(ordens) {
  const { data } = await api.put("/gtd/reordenar", { ordens });
  return data;
}

export async function removeGtdTicket(idTicket) {
  const { data } = await api.delete(`/gtd/tickets/${idTicket}`);
  return data;
}
